// via: http://stackoverflow.com/a/2117523/2511985

function getUniqueId(){
  var str = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return str.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
}

module.exports = getUniqueId;



//////////////////
// WEBPACK FOOTER
// ./~/keen-tracking/lib/helpers/getUniqueId.js
// module id = 1983
// module chunks = 0